import { ParentProps, Show, Signal, createContext, createSignal, onMount } from 'solid-js'
import { requireContext } from 'common'
import { ViewControlType, ViewControlContext } from './ViewControlContext'
import styles from './st-view-control.module.css'
import Button from '../st-button/st-button';

const ViewControlContextJsx = createContext<ViewControlContext<any>>();
export const requireViewControlContext = () => {
    return requireContext(ViewControlContextJsx);
}

export class ViewControlProps<T = any> {
    value!: Signal<T>;
    oldValue?: Signal<T>;
    label?: string;
    type?: ViewControlType;

    srcObject?: string;
    srcElement?: string;
    affectsStatus?: boolean;
}

export default function ViewControl<T = any>(props: ParentProps<ViewControlProps<T>>) {
    const oldValue = props.oldValue ?? createSignal<T>(props.value[0]());

    const context = new ViewControlContext<T>(props.value, oldValue, props.type);

    return (
        <ViewControlContextJsx.Provider value={context}>
            <ViewControlInternal {...props} />
        </ViewControlContextJsx.Provider>
    )
}

function ViewControlInternal(props: ParentProps<ViewControlProps>) {
    const viewControlCtx = requireViewControlContext();

    onMount(async () => {
        // const data = await api.Load();
    })

    return (
        <div class={`${styles['st-view-control']} flexbox`}>
            <div class={styles['actions-container']}>
                <Show when={props.affectsStatus && viewControlCtx.dirty()}>
                    <Button style='font-size: 0.8em; padding: 4px;' icon='fa fa-arrow-rotate-left' type='warning' onClick={() => viewControlCtx.undo()}></Button>
                </Show>
            </div>

            <Show when={props.label}>
                <label>{props.label}</label>
            </Show>
            {props.children}
        </div>
    );
}

ViewControl.defaultProps = new ViewControlProps();

// Explicit re-export here in order to make available at the bundle level.
export type {
    ViewControlType,
}